import React, { Component } from 'react'
import './App.css'

//import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'

import Res from './values/Resources'

import ScrollToTop from './components/ScrollToTop'
import asyncComponent from './components/AsyncComponent'

import Home from './pages/Home'
import Project from './pages/Project'

import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import brands from '@fortawesome/fontawesome-free-brands'
import { faTimes } from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(brands, faTimes)


const locale = require('browser-locale')()

const AsyncSliddingPuzzleDemo = asyncComponent(() => import('./tutorials/slidding-puzzle/SliddingPuzzleDemo'))
//const AsyncProject = asyncComponent(() => import('./pages/Project'))

export default class App extends Component {

	constructor(props) {
		super(props)

		let code = ''

		const languageCode = localStorage.getItem('language_code')
		//console.log(locale)

		if(languageCode) {
			code = languageCode
		} else {
			if(locale === 'pt-BR' || locale === 'pt-br' || locale === 'pt-Br')
				code = 'br'
			else
				code = 'en'

			localStorage.setItem('language_code', code)
		}

		Res.locale(code)
	}

	///*
	componentDidMount() {
		//window.addEventListener('scroll', this.handleScroll)
		//window.addEventListener('mousewheel', this.handleMouseWheel)
	}

	componentWillUnmount() {
		//window.removeEventListener('scroll', this.handleScroll)
		//window.removeEventListener('mousewheel', this.handleMouseWheel)
	}

	/*

	handleMouseWheel = (event) => {
		console.log('mousewheel')
		//console.log(event)
		this.deltaY += event.deltaY

		if(this.deltaY < 0)
			this.deltaY = 0

		//console.log('y = ' + this.deltaY)
	}

	handleScroll = (event) => {
		let { scrollTop } = event.srcElement.scrollingElement

		console.log('scroll ' + scrollTop)

		if(!this.state.menuVisible)
			this.lastScroll = scrollTop
		
		return

		if(scrollTop > this.lastScroll)
			this.setState({ menuBtnVisible: false })
		else
			if(scrollTop != 0)
				this.setState({ menuBtnVisible: true, menuBtnWhite: true })
			else if(scrollTop == 0)
				this.setState({ menuBtnVisible: true, menuBtnWhite: false })

		this.lastScroll = scrollTop
	}
	
	//*/

	render() {
		return ( 
			<Router>
				<Route
				  render={({ location }) => (
				  	<div className='app'>
						<ScrollToTop>
							{/*
							<TransitionGroup>
								<CSSTransition key={location.key} classNames='fade' timeout={100}>
									
								</CSSTransition>
							</TransitionGroup>
							*/}
							<Switch location={location}>
								<Route exact path='/' component={Home}/>
								<Route path='/projects/:id' component={Project}/>
								<Route path='/tutorials/slidding-puzzle/demo' component={AsyncSliddingPuzzleDemo}/>
								<Route render={() => (<h1>404 Not Found</h1>)}/>
							</Switch>

						</ScrollToTop>
					</div>
				  )}
				/>
			</Router>
		)
	}
}


// WEBPACK FOOTER //
// ./src/App.js